<ng-template [ngxPermissionsOnly]="['accounts:can_get_accounts_reports_receivables']">
  <div class="box-row panel panel-default">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{accountsReceiveable.receivables | currency:accountsReceiveable.currency_code: accountsReceiveable.currency_precision}}</div>
        <p>Accounts Receivable</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>